import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82453bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex ga-2 mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_3 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-0"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fila cabecera text-caption text-medium-emphasis" }, [
  /*#__PURE__*/_createElementVNode("span", null, "#"),
  /*#__PURE__*/_createElementVNode("span", null, "Jugador"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Total"),
  /*#__PURE__*/_createElementVNode("span", { class: "mejores text-center" }, "Sus 4 mejores")
], -1))
const _hoisted_5 = { class: "text-medium-emphasis" }
const _hoisted_6 = { class: "nick" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-center flex-wrap mt-1"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-medium-emphasis mt-2 mb-0" }, " Suma de sus 4 mejores resultados. Pulsa en unos puntos para ver la clasificación de ese evento. ", -1))
const _hoisted_10 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis mb-0"
}
const _hoisted_11 = {
  key: 3,
  class: "d-flex align-center flex-wrap ga-2 mt-3"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-medium-emphasis flex-grow-1" }, "Lo has creado tú.", -1))
const _hoisted_13 = {
  key: 1,
  class: "text-error mt-2"
}

import { computed, onMounted, ref } from "vue";
import { CircuitoDTO } from "@/interfaces/Circuito";
import {
  ResultadoCircuito,
  useCircuitoData,
} from "@/composables/useCircuitoData";
import { useAuth } from "@/composables/useAuth";
import {
  borrarCircuitoAsync,
  renombrarCircuitoAsync,
} from "@/services/CircuitosService";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import { esCircuitoAmonSul } from "@/utils/circuitoAmonSul";
import ModalNombreCircuito from "./components/ModalNombreCircuito.vue";
import ModalClasificacionEvento from "./components/ModalClasificacionEvento.vue";

const DE_ENTRADA = 5;
const TANDA = 50;
// Oro, plata y bronce para los resultados de podio, como en el resumen de un torneo

export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleCircuito',
  props: {
    circuito: {}
  },
  emits: ["renombrado", "borrado"],
  setup(__props: any, { emit: __emit }) {

const COLOR_PODIO: Record<number, string> = {
  1: "#FFD700",
  2: "#C0C0C0",
  3: "#CD7F32",
};

const props = __props;
const emit = __emit;

const pestana = ref<"clasificacion" | "eventos">("clasificacion");
const cuantos = ref(DE_ENTRADA);
const cargando = ref(true);

// Se carga al desplegarlo por primera vez; al recogerlo y volver a abrirlo ya está
const {
  torneos,
  clasificacion,
  loadTorneos,
  prepareClasificacion,
  posicionesDe,
} = useCircuitoData();
const visibles = computed(() => clasificacion.value.slice(0, cuantos.value));

onMounted(async () => {
  try {
    await loadTorneos(props.circuito);
    await prepareClasificacion();
  } catch (error) {
    console.error("Error al cargar el circuito:", error);
  } finally {
    cargando.value = false;
  }
});

// La clasificación de un evento en un modal: al cerrarlo se sigue en el circuito, como estaba
const showEvento = ref(false);
const eventoVisto = ref<ResultadoCircuito | null>(null);
const jugadorVisto = ref<number | null>(null);
const verEvento = (resultado: ResultadoCircuito, idUsuario: number) => {
  eventoVisto.value = resultado;
  jugadorVisto.value = idUsuario;
  showEvento.value = true;
};

const { getidUsuario } = useAuth();
const esCreador = computed(
  () =>
    props.circuito.idUsuario != null &&
    props.circuito.idUsuario === Number(getidUsuario.value) &&
    !esCircuitoAmonSul(props.circuito.nombreCircuito)
);

const guardando = ref(false);
const showRenombrar = ref(false);
const errorRenombrar = ref<string | null>(null);
const showBorrar = ref(false);
const errorBorrar = ref<string | null>(null);

const abrirRenombrar = () => {
  errorRenombrar.value = null;
  showRenombrar.value = true;
};

const renombrar = async (nombre: string) => {
  guardando.value = true;
  errorRenombrar.value = null;
  try {
    await renombrarCircuitoAsync(props.circuito.idCircuito, nombre);
    showRenombrar.value = false;
    emit("renombrado", nombre);
  } catch (error) {
    errorRenombrar.value = mensajeDelBack(
      error,
      "No se ha podido renombrar el circuito. Inténtalo de nuevo."
    );
  } finally {
    guardando.value = false;
  }
};

const borrar = async () => {
  guardando.value = true;
  errorBorrar.value = null;
  try {
    await borrarCircuitoAsync(props.circuito.idCircuito);
    showBorrar.value = false;
    emit("borrado", props.circuito.nombreCircuito);
  } catch (error) {
    errorBorrar.value = mensajeDelBack(
      error,
      "No se ha podido borrar el circuito. Inténtalo de nuevo."
    );
  } finally {
    guardando.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_chip, {
          size: "small",
          color: pestana.value === 'clasificacion' ? 'primary' : undefined,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (pestana.value = 'clasificacion'))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Clasificación ")
          ]),
          _: 1
        }, 8, ["color"]),
        _createVNode(_component_v_chip, {
          size: "small",
          color: pestana.value === 'eventos' ? 'primary' : undefined,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (pestana.value = 'eventos'))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Eventos (" + _toDisplayString(_unref(torneos).length) + ") ", 1)
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      (cargando.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "28"
            })
          ]))
        : (pestana.value === 'clasificacion')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(clasificacion).length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Aún no hay resultados en este circuito. "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_4,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (jugador) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: jugador.idUsuario,
                        class: "fila text-body-2"
                      }, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(jugador.posicion), 1),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(jugador.nick), 1),
                        _createElementVNode("strong", _hoisted_7, _toDisplayString(jugador.totalPuntos), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jugador.mejores, (resultado) => {
                          return (_openBlock(), _createBlock(_component_v_chip, {
                            key: resultado.idTorneo,
                            size: "x-small",
                            variant: COLOR_PODIO[resultado.resultado] ? 'flat' : 'tonal',
                            color: COLOR_PODIO[resultado.resultado],
                            class: "punto",
                            "aria-label": `${resultado.resultado}º en ${resultado.nombreTorneo}: ${resultado.puntos} puntos`,
                            onClick: ($event: any) => (verEvento(resultado, jugador.idUsuario))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(resultado.puntos), 1)
                            ]),
                            _: 2
                          }, 1032, ["variant", "color", "aria-label", "onClick"]))
                        }), 128))
                      ]))
                    }), 128)),
                    (_unref(clasificacion).length > DE_ENTRADA)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (cuantos.value < _unref(clasificacion).length)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                variant: "text",
                                size: "small",
                                color: "primary",
                                class: "text-none",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (cuantos.value = cuantos.value === DE_ENTRADA ? TANDA : cuantos.value + TANDA))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Ver más (" + _toDisplayString(_unref(clasificacion).length - cuantos.value) + ") ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (cuantos.value > DE_ENTRADA)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                variant: "text",
                                size: "small",
                                class: "text-none",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (cuantos.value = DE_ENTRADA))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Ver menos ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_9
                  ], 64))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_unref(torneos).length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Aún no tiene eventos. "))
                : (_openBlock(), _createBlock(_component_v_list, {
                    key: 1,
                    density: "compact",
                    "bg-color": "transparent",
                    class: "py-0"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(torneos), (torneo, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: torneo.idTorneo
                        }, [
                          (i > 0)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, {
                            to: `/detalle-evento/${torneo.idTorneo}`,
                            "append-icon": "mdi-chevron-right",
                            class: "px-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "text-body-2 nick" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(torneo.torneoNombre), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  }))
            ], 64)),
      (esCreador.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_v_btn, {
              size: "small",
              variant: "text",
              class: "text-none",
              onClick: abrirRenombrar
            }, {
              default: _withCtx(() => [
                _createTextVNode("Renombrar")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              size: "small",
              variant: "text",
              color: "error",
              class: "text-none",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showBorrar.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Borrar")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ModalClasificacionEvento, {
      modelValue: showEvento.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showEvento).value = $event)),
      evento: eventoVisto.value,
      posiciones: eventoVisto.value ? _unref(posicionesDe)(eventoVisto.value.idTorneo) : [],
      idUsuario: jugadorVisto.value
    }, null, 8, ["modelValue", "evento", "posiciones", "idUsuario"]),
    _createVNode(ModalNombreCircuito, {
      modelValue: showRenombrar.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showRenombrar).value = $event)),
      titulo: "Renombrar circuito",
      textoBoton: "Guardar",
      nombreInicial: _ctx.circuito.nombreCircuito,
      guardando: guardando.value,
      error: errorRenombrar.value,
      onGuardar: renombrar
    }, null, 8, ["modelValue", "nombreInicial", "guardando", "error"]),
    _createVNode(_component_v_dialog, {
      modelValue: showBorrar.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showBorrar).value = $event)),
      "max-width": "420"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-wrap" }, {
              default: _withCtx(() => [
                _createTextVNode("¿Borrar " + _toDisplayString(_ctx.circuito.nombreCircuito) + "?", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_unref(torneos).length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(torneos).length === 1
              ? "El evento que tiene deja"
              : `Los ${_unref(torneos).length} eventos que tiene dejan`) + " de estar en él; los eventos no se borran. ", 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createTextVNode(" No se puede deshacer. "),
                (errorBorrar.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(errorBorrar.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (showBorrar.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancelar")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "tonal",
                  loading: guardando.value,
                  onClick: borrar
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Borrar")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})